import '.h{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.l{justify-content:center;}.ssr-plugin'
import '.b5{min-height:100vh;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.f{padding:2rem;}.ssr-plugin'
import '.k{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="h i j l b5 ac f k"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
